module.exports = __webpack_public_path__ + "img/b71.f53d43ae.jpg";